{% block swag_cms_extensions_form_element_number %}
    <mt-number-field
        :modelValue="value"
        :label="field.translated ? field.translated.label : field.label"
        :required="field.required"
        :min="field.config.min"
        :max="field.config.max"
        :step="field.config.step"
        :disabled
    />
{% endblock %}
